import { Stack, Typography } from '@mui/material'
import { COLORS } from 'app-constants'

// this component is responsible for rendering a list of pills as well as the ability to select a specific pill
const Pill = ({
  index,
  text,
  isSelected,
  onSelectPill,
}: {
  index: number
  text: string
  isSelected: boolean
  onSelectPill: (pillIndex: number) => void
}) => {
  const onClickPill = () => {
    onSelectPill(index)
  }

  return (
    <Stack
      p="4px 12px"
      borderRadius="20px"
      justifyContent="center"
      alignItems="center"
      gap="10px"
      onClick={onClickPill}
      sx={{
        cursor: 'pointer',
        border: isSelected ? `1px solid ${COLORS.JELLED_PRIMARY_BLUE}` : `1px solid ${COLORS.GRAY_5}`,
        backgroundColor: isSelected ? COLORS.JELLED_MID_BLUE_10_PERCENT : COLORS.PURE_WHITE,
        '&:hover': {
          backgroundColor: isSelected ? COLORS.JELLED_MID_BLUE_10_PERCENT : COLORS.GRAY_8,
        },
      }}>
      <Typography
        variant="body0"
        sx={{
          color: isSelected ? COLORS.JELLED_PRIMARY_BLUE : COLORS.GRAY_0,
        }}>
        {text}
      </Typography>
    </Stack>
  )
}

const PillSelector = ({
  pills,
  selectedIndex,
  onSelectPill,
}: {
  pills: string[]
  selectedIndex: number
  onSelectPill: (pillIndex: number) => void
}) => {
  return (
    <Stack direction="row" spacing={1}>
      {pills.map((p, idx) => (
        <Pill key={idx} index={idx} text={p} isSelected={idx === selectedIndex} onSelectPill={onSelectPill} />
      ))}
    </Stack>
  )
}

export default PillSelector
